import { Text } from '@viapeople/components'

export type DataFeedRunRow = {
	id: string
	fileName: string | null
	status: string
	recordsProcessed: number | null
	startedAt: Date | string | null
}

export function DataFeedRecentRunsSection({ runs }: { runs: DataFeedRunRow[] }) {
	if (runs.length === 0) {
		return null
	}

	return (
		<div className='mt-6'>
			<Text variant='medium' weight='semibold' className='mb-3'>
				Recent Runs
			</Text>
			<div className='max-h-48 overflow-y-auto border border-neutral-200 rounded-lg'>
				<table className='w-full text-sm'>
					<thead className='bg-neutral-50 sticky top-0'>
						<tr>
							<th className='text-left px-3 py-2 font-medium text-neutral-600'>File</th>
							<th className='text-left px-3 py-2 font-medium text-neutral-600'>Status</th>
							<th className='text-left px-3 py-2 font-medium text-neutral-600'>Records</th>
							<th className='text-left px-3 py-2 font-medium text-neutral-600'>Date</th>
						</tr>
					</thead>
					<tbody>
						{runs.map((run) => (
							<tr key={run.id} className='border-t border-neutral-100'>
								<td className='px-3 py-2 truncate max-w-[150px]' title={run.fileName ?? undefined}>
									{run.fileName || '-'}
								</td>
								<td className='px-3 py-2'>
									<span
										className={`px-1.5 py-0.5 rounded text-xs font-medium ${
											run.status === 'success'
												? 'bg-success-50 text-success-700'
												: run.status === 'failed'
													? 'bg-danger-50 text-danger-700'
													: 'bg-neutral-50 text-neutral-600'
										}`}>
										{run.status}
									</span>
								</td>
								<td className='px-3 py-2'>{run.recordsProcessed ?? 0}</td>
								<td className='px-3 py-2'>{run.startedAt ? new Date(run.startedAt).toLocaleString() : '-'}</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	)
}
